import React, { useState } from "react";
import { useLoaderData } from "react-router-dom";
import { Panel } from "primereact/panel";
import {
    addToolQuestion,
    deleteQuestion,
    generateToolQuestions,
    getToolSatisfactionQuestions,
    getToolSatisfactionStats,
    reorderToolQuestions,
    updateQuestion
} from "../../../data/loca/satisfaction";
import QuestionsManager from "../satisfaction/QuestionsManager";
import { CommentsList, Distribution, KpiGrid, QuestionResults } from "../satisfaction/SatisfactionStats";
import "../../../assets/css/satisfaction.css";

// Onglet "Satisfaction" d'un outil : resultats des questionnaires + gestion des questions specifiques.

export async function loader({ params }) {
    const [questionsData, stats] = await Promise.all([
        getToolSatisfactionQuestions(params.toolId),
        getToolSatisfactionStats(params.toolId).catch(() => null)
    ]);

    return { toolId: params.toolId, questionsData, stats };
}

export default function ToolSatisfactionPage() {
    const { toolId, questionsData, stats } = useLoaderData();
    const [questions, setQuestions] = useState(questionsData?.questions ?? []);
    const generalQuestions = questionsData?.general ?? [];

    return (
        <div id="mainContent">
            <div className="contentForm"></div>
            <Panel className="tool-details-panel" header="Satisfaction des locataires">
                {!stats || stats.surveysCount === 0 ? (
                    <p className="sat-empty">
                        Aucun questionnaire pour cet outil pour le moment. Un questionnaire est envoyé automatiquement au locataire à la clôture de chaque location.
                    </p>
                ) : (
                    <>
                        <KpiGrid stats={stats} />
                        <div className="sat-results-grid">
                            <div className="sat-result-card">
                                <h4>Répartition des notes globales</h4>
                                <Distribution items={stats.scoreDistribution} reverse />
                            </div>
                            <div className="sat-result-card">
                                <h4>Derniers commentaires</h4>
                                <CommentsList comments={stats.recentComments} />
                            </div>
                        </div>
                        <h3 className="mt-4">Détail par question</h3>
                        <QuestionResults questions={stats.questions} />
                    </>
                )}
            </Panel>

            <div className="contentForm"></div>
            <Panel className="tool-details-panel" header="Questions spécifiques à cet outil">
                <p className="text-muted">
                    Ces questions s'ajoutent aux questions générales posées à chaque location. Gardez-en 2 ou 3 maximum : le questionnaire doit rester rapide à remplir.
                </p>
                <QuestionsManager
                    questions={questions}
                    onChange={setQuestions}
                    addQuestion={(input) => addToolQuestion(toolId, input)}
                    updateQuestion={updateQuestion}
                    deleteQuestion={deleteQuestion}
                    reorderQuestions={(publicIds) => reorderToolQuestions(toolId, publicIds)}
                    generateQuestions={(ia) => generateToolQuestions(toolId, ia)}
                    allowGenerate
                    allowIA
                    emptyMessage="Aucune question spécifique : elles seront générées automatiquement à la première location terminée, ou dès maintenant avec le bouton ci-dessous."
                />
                {generalQuestions.length > 0 && (
                    <div className="mt-4">
                        <h4>Questions générales (posées à chaque location)</h4>
                        <ul className="sat-general-list">
                            {generalQuestions.map((question) => (
                                <li key={question.publicId}>{question.label}{question.isRequired ? " (obligatoire)" : ""}</li>
                            ))}
                        </ul>
                    </div>
                )}
            </Panel>
            <div className="contentForm"></div>
        </div>
    );
}
